import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { CAROUSEL_LANDSCAPE_W_BODY_CTA } from '../../../../constants/UiBuilderConst';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import CTASelector from '../../../../shared/ui-builder/cta-selector/CTA-Selector';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import HotelModuleSelector from '../../../../shared/ui-builder/hotel-module-selector/Hotel-Module-Selector';
import ModuleIdSelector from '../../../../shared/ui-builder/module-id-selector/Module-Id-Selector';
import { Add } from '@material-ui/icons';
import ViewAllSelector from '../../../../shared/ui-builder/view-all-selector/View-All-Selector';
import DraggableTabsList from '../../../../shared/draggable-tabs-list/Draggable-Tabs-List';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

//2D Landscape C body CTA
const LandscapeCarouselWithBodyCta = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;
  const initialSlide = [
    {
      id: `slide_1`,
      label: `Slide 1`,
      imgURL: null,
      titleH2: '',
      body: '',
      cta: {
        isActive: false,
        title: '',
      },
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_2`,
      label: `Slide 2`,
      imgURL: null,
      titleH2: '',
      body: '',
      cta: {
        isActive: false,
        title: '',
      },
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_3`,
      label: `Slide 3`,
      imgURL: null,
      titleH2: '',
      body: '',
      cta: {
        isActive: false,
        title: '',
      },
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_4`,
      label: `Slide 4`,
      imgURL: null,
      titleH2: '',
      body: '',
      cta: {
        isActive: false,
        title: '',
      },
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
  ];
  const addNewSlide = {
    id: '',
    label: '',
    imgURL: null,
    titleH2: '',
    body: '',
    cta: {
      isActive: false,
      title: '',
    },
    redirectLink: {
      connection: '',
      linkId: '',
      isActive: false,
    },
    shadowOverlay: false,
    loopPlayBack: false,
    isVideo: false,
    videoURL: null,
  };
  const [slidesList, setSlidesList] = useState(
    config.slides && config.slides.length
      ? config.slides.map((e, index) => {
          return {
            ...e,
            id: `slide_${index + 1}`,
            label: `Slide ${index + 1}`,
          };
        })
      : initialSlide,
  );
  const [hotelModule, setHotelModule] = useState(config?.hotelModule || '');
  const [activeTabIndex, setActveTabIndex] = useState(0);
  const [activeTabContent, setActveTabContent] = useState(slidesList[0]);
  const [viewAll, setViewAll] = useState(
    config?.viewAll ? config.viewAll : { isActive: true, linkId: '' },
  );
  const [error, setError] = useState(null);
  const [hotelSubModuleName, setHotelSubModuleName] = useState([]);
  const [isSwapEnabled, setIsSwapEnabled] = useState(false);
  const maxSlidesCount = 20;

  useEffect(() => {
    if (config.slides && config.slides.length) {
      const setHotelModule = config.slides.map((currSliderValue, ndx) => {
        return { index: ndx, name: currSliderValue.titleH2 };
      });
      setHotelSubModuleName(setHotelModule);
    }
  }, []);

  useEffect(() => {
    const currSlider = slidesList?.map((sliderValue, ndx) => {
      if (sliderValue.hotelModuleId && !sliderValue.titleH2) {
        const subModule = hotelSubModuleName.find((val) => val.index === ndx);
        return { ...sliderValue, titleH2: subModule?.name };
      }
      return { ...sliderValue };
    });
    onItemChange({
      componentName: CAROUSEL_LANDSCAPE_W_BODY_CTA,
      config: {
        hotelModule: hotelModule,
        slides: currSlider.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
      },
    });
  }, [slidesList, hotelModule, viewAll, isSwapEnabled]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      setIsSwapEnabled(false);
      const currError = handleError.find(
        (getError) =>
          getError.pos === componentNdx && getError.id === CAROUSEL_LANDSCAPE_W_BODY_CTA,
      );
      if (currError && currError.slides.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.slides.map((o) => o.pos),
        );
        setActveTabIndex(sliderNdx);
        setActveTabContent(slidesList[sliderNdx]);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    }
    if (val?.type) return '';
    return 'required';
  };

  const handleTabData = (val, slideContent, field, moduleName) => {
    const thisErr = setErrorField(field, val);
    const newSlidesErr = slidesList?.map((_, idx) => {
      const prev = error?.slides?.find((e) => e?.pos === idx) || { pos: idx };
      return idx === activeTabIndex ? { ...prev, [field]: thisErr } : prev;
    });
    const newConfigErr = { ...(error?.config || {}) };
    setError({ config: newConfigErr, slides: newSlidesErr });
    switch (field) {
      case 'titleH2':
        slideContent.titleH2 = val;
        break;
      case 'body':
        slideContent.body = val;
        break;
      case 'imgURL':
        slideContent.imgURL = val;
        break;
      case 'redirect':
        slideContent.redirectLink.connection = val.type;
        slideContent.redirectLink.linkId = val.value;
        break;
      case 'isActive':
        slideContent.redirectLink.isActive = val;
        break;
      case 'isCTAActive':
        slideContent.cta.isActive = val;
        break;
      case 'ctaTitle':
        slideContent.cta.title = val;
        break;
      case 'viewAll':
        setViewAll({
          ...viewAll,
          linkId: val,
        });
        break;
      case 'viewAllStatus':
        setViewAll({
          ...viewAll,
          isActive: val,
        });
        break;
      case 'isVideo':
        slideContent.isVideo = val;
        break;
      case 'shadowOverlay':
        slideContent.shadowOverlay = val;
        break;
      case 'videoURL':
        slideContent.videoURL = val;
        break;
      case 'loopPlayBack':
        slideContent.loopPlayBack = val;
        break;
      case 'hotelModuleId':
        slideContent.hotelModuleId = val ? val : '';
        slideContent.titleH2 = moduleName ? moduleName : '';
        const currentsubModuleName = [...hotelSubModuleName];
        const checkExistingModuleNdx = currentsubModuleName.findIndex(
          (moduleValue) => moduleValue.index === activeTabIndex,
        );
        if (checkExistingModuleNdx > -1) {
          currentsubModuleName[checkExistingModuleNdx].name = moduleName;
        } else {
          currentsubModuleName.push({
            index: activeTabIndex,
            name: moduleName,
          });
        }
        setHotelSubModuleName(currentsubModuleName);
      default:
        break;
    }
    setSlidesList(
      slidesList.map((slide, index) => {
        if (index === activeTabIndex) {
          return slideContent;
        } else {
          return slide;
        }
      }),
    );
  };

  const onTabChange = (e, value) => {
    setActveTabIndex(value);
    setActveTabContent(slidesList[value]);
  };

  const hasError = (key, isReturnString = false) => {
    const hasSliderError = error?.slides?.find(
      (errorSlider) =>
        errorSlider.pos === activeTabIndex &&
        (errorSlider[key] === 'required' || errorSlider[key] === 'validUrl' || errorSlider[key] === 'safeDomain'),
    );
    if (isReturnString && hasSliderError) return hasSliderError?.videoURL;
    if (hasSliderError) return true;
    return false;
  };

  const onChangeHotelModule = (val) => {
    setHotelModule(val || '');
    setHotelSubModuleName([]);
    const tempSlidesList = slidesList.map((slide) => {
      return { ...slide, hotelModuleId: '', titleH2: '' };
    });
    setSlidesList(tempSlidesList);
    setActveTabContent(tempSlidesList[activeTabIndex]);
  };

  const AddNewSlide = (e) => {
    if (slidesList.length < maxSlidesCount) {
      const tempSlidesList = [...slidesList];
      addNewSlide.id = `slide_${slidesList.length + 1}`;
      addNewSlide.label = `Slide ${slidesList.length + 1}`;
      tempSlidesList.push(addNewSlide);
      setSlidesList(tempSlidesList);
      setActveTabIndex(tempSlidesList.length - 1);
      setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
    }
  };

  const removeSlide = (e) => {
    if (slidesList.length > 1) {
      const tempSlidesList = [...slidesList];
      tempSlidesList.splice(activeTabIndex, 1);
      setSlidesList(tempSlidesList);
      if (activeTabIndex === tempSlidesList.length) {
        setActveTabIndex(tempSlidesList.length - 1);
        setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
      } else {
        setActveTabContent(tempSlidesList[activeTabIndex]);
      }
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const newTabs = slidesList;
    const draggedTab = newTabs.splice(result.source.index, 1)[0];
    newTabs.splice(result.destination.index, 0, draggedTab);
    setActveTabIndex(result.destination.index);
    setActveTabContent(draggedTab);
    setSlidesList(newTabs);
    setIsSwapEnabled(true);
    const currSlider = slidesList?.map((sliderValue, ndx) => {
      if (sliderValue.hotelModuleId && !sliderValue.titleH2) {
        const subModule = hotelSubModuleName.find((val) => val.index === ndx);
        return { ...sliderValue, titleH2: subModule?.name };
      }
      return { ...sliderValue };
    });
    onItemChange({
      componentName: CAROUSEL_LANDSCAPE_W_BODY_CTA,
      config: {
        hotelModule: hotelModule,
        slides: currSlider.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
      },
    });
  };

  return (
    <div className='row my-2 mx-1'>
      <div className='col-md-10'>
        <div className='col-md-12 mb-3'>
          <HotelModuleSelector
            hotelModule={hotelModule}
            onChangeHotelModule={(e) => onChangeHotelModule(e)}
          />
        </div>
        <div className='row mb-3'>
          <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
            <DraggableTabsList
              onDragEnd={onDragEnd}
              tabs={slidesList}
              onTabChange={onTabChange}
              activeTabIndex={activeTabIndex}
            />
            <div className='ms-2'>
              <Button
                disabled={slidesList.length >= maxSlidesCount}
                variant='outlined'
                size='medium'
                color='secondary'
                onClick={(e) => AddNewSlide(e)}
              >
                <Add />
              </Button>
            </div>
          </div>
          <div className='col-md-12 pe-1 mt-3'>
            <div className='d-flex justify-content-between px-3 py-2 remove-slide-div'>
              <div>Slide {activeTabContent?.id?.split('_')[1]}</div>
              <div className='text-underlined pointer' onClick={(e) => removeSlide(e)}>
                Remove
              </div>
            </div>
            {hotelModule && (
              <div className='col-md-12'>
                <ModuleIdSelector
                  key={activeTabContent?.id}
                  hotelModule={hotelModule}
                  hotelModuleId={activeTabContent.hotelModuleId}
                  onChangeHotelModuleId={(e, moduleName) =>
                    handleTabData(e.target.value, activeTabContent, 'hotelModuleId', moduleName)
                  }
                />
              </div>
            )}
            <div className='col-md-12'>
              <CustomUiBuilderTextField
                label='H2 Title'
                required={!Boolean(activeTabContent.hotelModuleId)}
                className='col-md-12 mt-3'
                value={activeTabContent.titleH2}
                onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'titleH2')}
                maxLength={100}
                isAdornment={true}
                endAdornment={true}
                error={
                  activeTabContent.hotelModuleId ? false : !isSwapEnabled && hasError('titleH2')
                }
              />
              <div className='col-md-12 mt-4'>
                <CustomUiBuilderTextField
                  label='body1'
                  required={true}
                  className='col-md-12 mt-3'
                  value={activeTabContent.body}
                  onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'body')}
                  maxLength={500}
                  isAdornment={true}
                  endAdornment={true}
                  multiline={true}
                  error={!isSwapEnabled && hasError('body')}
                />
              </div>
              <div className='col-md-12 mt-4'>
                <MediaSelector
                  groupId={groupId}
                  titleH2={'Image'}
                  height={364}
                  width={604}
                  matrix={'px'}
                  handleTabData={handleTabData}
                  activeTabContent={activeTabContent}
                  isSwapEnabled={isSwapEnabled}
                  setIsSwapEnabled={setIsSwapEnabled}
                  hasError={hasError}
                  ratio={'3:2'}
                />
              </div>
              <div className='col-md-12 mt-4'>
                <CTASelector
                  onValueChange={(e) => handleTabData(e, activeTabContent, 'ctaTitle')}
                  value={activeTabContent.cta.title}
                  onCTAStatusChange={(e) => {
                    handleTabData(e, activeTabContent, 'isCTAActive');
                  }}
                  isActive={activeTabContent.cta.isActive}
                  isRequired={activeTabContent.cta.isActive ? true : false}
                  error={!isSwapEnabled && hasError('ctaTitle')}
                />
              </div>
              <div className='col-md-12 mt-4'>
                <RedirectSelector
                  onValueChange={(e) => handleTabData(e, activeTabContent, 'redirect')}
                  redirectType={activeTabContent.redirectLink.connection}
                  value={activeTabContent.redirectLink.linkId}
                  onRedirectChange={(e) => {
                    handleTabData(e, activeTabContent, 'isActive');
                  }}
                  isActive={activeTabContent.redirectLink.isActive}
                  error={!isSwapEnabled && hasError('redirect')}
                />
              </div>
              <div className='col-md-12 mt-4'>
                <ViewAllSelector
                  onValueChange={(e) => handleTabData(e, activeTabContent, 'viewAll')}
                  value={viewAll.linkId}
                  onViewAllStatusChange={(e) => {
                    handleTabData(e, activeTabContent, 'viewAllStatus');
                  }}
                  isActive={viewAll.isActive}
                  isRequired={viewAll.isActive ? true : false}
                  error={
                    !isSwapEnabled && viewAll.linkId === '' && error?.config?.viewAll === 'required'
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandscapeCarouselWithBodyCta;
